module.exports = __webpack_public_path__ + "img/other_events.86cb5c24.png";